import {
  defaultShouldDehydrateQuery,
  MutationCache,
  QueryCache,
  QueryClient,
} from "@tanstack/react-query";
import { notifyTrpcError } from "./error-notify-sink";
import { getTrpcErrorMessage, shouldSuppressTrpcErrorToast } from "./errors";

const handleTrpcError = (error: unknown, meta: unknown) => {
  if (shouldSuppressTrpcErrorToast(meta)) {
    return;
  }

  notifyTrpcError(getTrpcErrorMessage(error));
};

export function makeQueryClient() {
  return new QueryClient({
    queryCache: new QueryCache({
      onError: (error, query) => {
        handleTrpcError(error, query.meta);
      },
    }),
    mutationCache: new MutationCache({
      onError: (error, _variables, _context, mutation) => {
        handleTrpcError(error, mutation.meta);
      },
    }),
    defaultOptions: {
      queries: {
        staleTime: 30 * 1000,
      },
      dehydrate: {
        shouldDehydrateQuery: (query) =>
          defaultShouldDehydrateQuery(query) ||
          query.state.status === "pending",
      },
      hydrate: {},
    },
  });
}
